'use es6';

export const HISTORY_LIMIT = 100;